export default __webpack_public_path__ + "images/loteDefault.4ae288af33d27cd8cfd5206373d265fa.jpg";